import { type ReactNode } from 'react';
import { useInView } from '../hooks/useInView';

interface RevealProps {
  children: ReactNode;
  className?: string;
  delayMs?: number;
}

/**
 * Wraps children and applies the fade-up animation once the element scrolls
 * into view (sticky — does not re-trigger on scroll-back).
 */
export default function Reveal({
  children,
  className,
  delayMs = 0,
}: RevealProps) {
  const [ref, seen] = useInView<HTMLDivElement>(0.2);
  return (
    <div
      ref={ref}
      style={delayMs ? { animationDelay: `${delayMs}ms` } : undefined}
      className={`${seen ? 'animate-fade-up' : 'opacity-0'} ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
